import React from 'react';
import { Navbar } from '../components/landing/Navbar';
import { Hero } from '../components/landing/Hero';
import { Problem } from '../components/landing/Problem';
import { Solution } from '../components/landing/Solution';
import { CaseStudy } from '../components/landing/CaseStudy';
import { Features } from '../components/landing/Features';
import { ForResorts } from '../components/landing/ForResorts';
import { ForAgencies } from '../components/landing/ForAgencies';
import { BusinessModel } from '../components/landing/BusinessModel';
import { AICapabilities } from '../components/landing/AICapabilities';
import { Roadmap } from '../components/landing/Roadmap';
import { CTASection } from '../components/landing/CTASection';
import { Footer } from '../components/landing/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-stone-50 font-sans text-stone-900" data-id="element-1213">
      <Navbar data-id="element-1214" />
      <main data-id="element-1215">
        <Hero data-id="element-1216" />
        <Problem data-id="element-1217" />
        <Solution data-id="element-1218" />
        <CaseStudy data-id="element-1219" />
        <Features data-id="element-1220" />
        <ForResorts data-id="element-1221" />
        <ForAgencies data-id="element-1222" />
        <BusinessModel data-id="element-1223" />
        <AICapabilities data-id="element-1224" />
        <Roadmap data-id="element-1225" />
        <CTASection data-id="element-1226" />
      </main>
      <Footer data-id="element-1227" />
    </div>;
}